import * as yup from "yup";

const createFeatureSuggestionSchema = (t) =>
    yup.object().shape({
        email: yup
            .string()
            .email(t("validation.pleaseEnterValidEmail"))
            .required(t("validation.emailRequired")),
        name: yup.string().required(t("validation.nameRequired")),
        feature: yup
            .string()
            .min(10, t("validation.featureMinLength"))
            .required(t("validation.featureRequired")),
    });

export default createFeatureSuggestionSchema;